<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()"
            class="voip-peers-search">
    <div class="search-container">
        <div class="search-column">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input [(ngModel)]="search.name" matInput>
            </mat-form-field>
          <ac-input-container label="CAC State">
            <ac-select
              [(acModel)]="search.cacState"
              [items]="search.cacStateOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>

          <ac-input-container label="CAC Profile">
              <ac-select
                [(acModel)]="search.cacProfileId"
                [items]="search.cacProfiles"
                [allowClear]="true"
                [multiple]="false"
                [bindValue]="'value'"
                [bindLabel]="'text'">
              </ac-select>
          </ac-input-container>

          <ac-input-container label="Peer Connections" class="peer-connections">
            <ac-select
              [(acModel)]="search.pConId"
              [items]="search.peerConnections"
              [allowClear]="true"
              [multiple]="true"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>
    </div>
</arm-dialog>
